import React from "react";

import { Button, Modal } from "shared/ui";

import { usePaymentsHistoryContext } from "features/PaymentsHistory/context";

export const CancelInvoiceDialog = () => {
    const state = usePaymentsHistoryContext();
    const invoice = state.invoiceToCancel;

    return (
        <Modal
            open={!!invoice}
            onClose={state.closeCancelDialog}
            title="Отменить счёт?"
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={state.closeCancelDialog}>
                        Не отменять
                    </Button>
                    <Button
                        variant="contained"
                        color="danger"
                        disabled={state.cancelling}
                        onClick={state.confirmCancel}
                    >
                        Отменить счёт
                    </Button>
                </>
            }
        >
            {invoice && (
                <>
                    Счёт {invoice.invoiceId} на {state.formatPrice(invoice.price)} будет отменён и
                    пропадёт из истории. Оплатить его после этого не получится — понадобится новый.
                </>
            )}
        </Modal>
    );
};
